import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useCallback, useState } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { ResourcedEmoji } from '@atlaskit/emoji/element';
import Tabs, { Tab, TabList } from '@atlaskit/tabs';
import { useThemeObserver } from '@atlaskit/tokens';
import { Counter } from '../Counter';
import { counterStyle, customTabWrapper, customTabListStyles } from './styles';
import { ReactionView } from './ReactionView';
export var ReactionsList = function ReactionsList(_ref) {
  var reactions = _ref.reactions,
    initialEmojiId = _ref.initialEmojiId,
    emojiProvider = _ref.emojiProvider,
    onReactionChanged = _ref.onReactionChanged;
  var _useState = useState(function () {
      // Calculate this only on initialize the List of Tabs and each Reactions View collection
      return {
        index: reactions.findIndex(function (reaction) {
          return reaction.emojiId === initialEmojiId;
        }),
        id: initialEmojiId
      };
    }),
    _useState2 = _slicedToArray(_useState, 2),
    selectedEmoji = _useState2[0],
    setSelectedEmoji = _useState2[1];
  var _useThemeObserver = useThemeObserver(),
    colorMode = _useThemeObserver.colorMode;
  var onTabChange = useCallback(function (index, analyticsEvent) {
    if (index === selectedEmoji.index) {
      return;
    }
    var emojiId = reactions[index].emojiId;
    setSelectedEmoji({
      index: index,
      id: emojiId
    });
    onReactionChanged(emojiId, analyticsEvent);
  }, [selectedEmoji.index, reactions, onReactionChanged]);
  return jsx(Tabs, {
    id: "reactions-dialog-tabs",
    onChange: onTabChange,
    selected: selectedEmoji.index
  }, jsx("div", {
    css: customTabListStyles,
    id: "reactions-dialog-tabs-list"
  }, jsx(TabList, null, reactions.map(function (reaction) {
    var emojiId = {
      id: reaction.emojiId,
      shortName: ''
    };
    return jsx("div", {
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      css: customTabWrapper((emojiId === null || emojiId === void 0 ? void 0 : emojiId.id) === selectedEmoji.id, selectedEmoji.id, colorMode)
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      ,
      className: "reaction-elements",
      key: reaction.emojiId,
      "data-testid": emojiId === null || emojiId === void 0 ? void 0 : emojiId.id
    }, jsx(Tab, null, jsx(ResourcedEmoji, {
      emojiProvider: emojiProvider,
      emojiId: emojiId,
      fitToHeight: 16,
      showTooltip: true
    }), jsx("div", {
      css: counterStyle((emojiId === null || emojiId === void 0 ? void 0 : emojiId.id) === selectedEmoji.id)
    }, jsx(Counter, {
      value: reaction.count
    }))));
  }))), reactions.map(function (reaction) {
    return jsx(ReactionView, {
      key: reaction.emojiId,
      reaction: reaction,
      selectedEmojiId: selectedEmoji.id,
      emojiProvider: emojiProvider
    });
  }));
};